import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app-core/services/common.service';

@Component({
  selector: 'app-orders-conatiner-future-use-form',
  templateUrl: './orders-conatiner-future-use-form.component.html',
  styleUrls: ['./orders-conatiner-future-use-form.component.scss']
})
export class OrdersConatinerFutureUseFormComponent implements OnInit {

  containerDetails: any;
  isFormLoading = false;
  containerName: string;

  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<OrdersConatinerFutureUseFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.containerDetails = this.data.containerDetails;
  }

  isDisabledSubmitButton() {
    return (this.containerName && this.containerName.trim().length > 0) ? false : true;
  }

  onSave() {
    this.containerDetails.containerName = this.containerName;
    this.commonService.createFutureUseContainer(this.containerDetails).subscribe(response => {
      if (response.isSuccess) {
        this.toastr.success('Saved container for Future use');
        const sendingData = {
          confirmResult: true
        };
        this.dialogRef.close(sendingData);
      }
      else
      {
        this.toastr.warning(response.errors);
      }
    });
   
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

}
